
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"circle",attrs:{"d":"M18.796 10.616c-.432.024-.75.072-.954.144a.648.648 0 00-.396.414c-.072.204-.108.534-.108.99v8.928c0 .456.036.786.108.99a.648.648 0 00.396.414c.204.072.522.12.954.144V23a37.257 37.257 0 00-2.286-.054c-1.032 0-1.8.018-2.304.054v-.36c.432-.024.744-.072.936-.144a.647.647 0 00.414-.414c.072-.204.108-.534.108-.99v-8.928c0-.456-.036-.786-.108-.99a.647.647 0 00-.414-.414c-.192-.072-.504-.12-.936-.144v-.36c.504.036 1.272.054 2.304.054.96 0 1.722-.018 2.286-.054v.36z","opacity":".8"}}),_c('path',{staticClass:"letter",attrs:{"clip-rule":"evenodd","d":"M16 31c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15z"}})])
          )
        }
      }
    